import React, { useCallback, useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { makeStyles, Theme } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useSelector, useDispatch } from "react-redux";
import useMedia from "use-media";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";

import {
  selectSelectedMenu,
  editRecord,
  selectEditedRecord,
  selectSelectTargetDay,
  selectLastRecord,
  initialState,
  selectEditedOriginalMenu,
  editOriginalMenu,
  fetchAsyncCreateOriginalMenu,
  fetchAsyncUpdateOriginalMenu,
} from "../home/homeSlice";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    width: "100%",
    padding: theme.spacing(3, 1),
    margin: 0,
    boxSizing: "border-box",
    zIndex: 2,
    backgroundColor: "#f1f9ff",
    maxWidth: "66.667%",
  },
  paperRes: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    width: "100%",
    padding: theme.spacing(3, 1),
    margin: 0,
    boxSizing: "border-box",
    zIndex: 2,
    backgroundColor: "#f1f9ff",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    borderRadius: 8,
    backgroundColor: "#fff",
    padding: theme.spacing(2, 2),
    boxSizing: "border-box",
  },

  color: {
    color: "#2699FB",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#2699FB",
  },
  lastTimeBtn: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#6699cc",
  },

  headerBack: {
    paddingRight: theme.spacing(3),
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  record: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
    marginBottom: 10,
  },
  add: {
    fontSize: 60,
    color: "#2699FB",
  },
  remove: {
    fontSize: 60,
    color: "#ffc184",
    marginRight: 10,
  },
  unit: {
    paddingRight: theme.spacing(1),
  },
  recordItem: {
    width: "50%",
  },
  formControl: {
    width: "100%",
    margin: theme.spacing(1, 0),
  },
  selectValue: {
    paddingLeft: theme.spacing(1),
  },
}));

const CreateMenu: React.FC = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const selectedMenu = useSelector(selectSelectedMenu);
  const editedRecord = useSelector(selectEditedRecord);
  const targetDay = useSelector(selectSelectTargetDay);
  const editedOriginalMenu = useSelector(selectEditedOriginalMenu);
  const lastRecord = useSelector(selectLastRecord);
  const isWide = useMedia({ minWidth: "600px" });

  const handleChangeSelect = async (
    e: React.ChangeEvent<{ name?: string | undefined; value: unknown }>
  ) => {
    if (e.target.name === "part") {
      await dispatch(
        editOriginalMenu({
          ...editedOriginalMenu,
          part: e.target.value as string,
          color: e.target.value as string,
        })
      );
    }
    if (e.target.name === "type") {
      await dispatch(
        editOriginalMenu({
          ...editedOriginalMenu,
          type: e.target.value as string,
        })
      );
    }
  };

  const handleChangeTitle = async (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    await dispatch(
      editOriginalMenu({
        ...editedOriginalMenu,
        title: e.target.value as string,
      })
    );
  };

  //回数、セット追加
  const addRecord = () => {
    if (editedRecord.length < 10) {
      dispatch(
        editRecord([
          ...editedRecord,
          {
            id: 0,
            menu_id: selectedMenu.id,
            weight: null,
            number_value: 0,
            set_value: null,
            date: targetDay,
          },
        ])
      );
    }
  };

  //回数、セット削除
  const removeRecord = () => {
    if (editedRecord.length > 1) {
      let newRecord = [...editedRecord];
      newRecord.pop();
      dispatch(editRecord(newRecord));
    }
  };
  //画面遷移
  const backProfile = useCallback(async () => {
    await history.goBack();
    await dispatch(editRecord(initialState.editedRecord));
  }, [history, dispatch]);

  const handleCreateMenu = async (e: React.FormEvent<HTMLFormElement>) => {
    await e.preventDefault();
    (await editedOriginalMenu.id) === 0
      ? await dispatch(fetchAsyncCreateOriginalMenu(editedOriginalMenu))
      : await dispatch(fetchAsyncUpdateOriginalMenu(editedOriginalMenu));

    await history.push("/home/menu/list");
  };

  //新規作成時に、レコードのmenuとdateを格納する
  //既存のレコード編集時には処理しない
  useEffect(() => {
    if (editedRecord.length > 0 && editedRecord[0].id === 0) {
      dispatch(
        editRecord([
          {
            id: 0,
            menu_id: selectedMenu.id,
            weight: null,
            number_value: 0,
            set_value: null,
            date: targetDay,
          },
        ])
      );
    }
  }, [dispatch]);

  return (
    <Grid container>
      <Grid item xs={12} component={Paper} elevation={6} square>
        <div className={isWide ? classes.paper : classes.paperRes}>
          <div className={classes.header}>
            <div className={classes.headerBack}>
              <ArrowBackIcon onClick={backProfile} />
            </div>
          </div>
          <form className={classes.form} onSubmit={handleCreateMenu}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="menuTitle"
              name="menuTitle"
              label="タイトル"
              value={editedOriginalMenu.title}
              onChange={handleChangeTitle}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AssignmentIcon />
                  </InputAdornment>
                ),
              }}
            />
            <FormControl className={classes.formControl}>
              <InputLabel id="part-container">部位</InputLabel>
              <Select
                labelId="part-label"
                id="part"
                value={editedOriginalMenu.part}
                name="part"
                required
                onChange={handleChangeSelect}
                className={classes.selectValue}
              >
                <MenuItem value={1}>胸</MenuItem>
                <MenuItem value={2}>腹</MenuItem>
                <MenuItem value={3}>腕</MenuItem>
                <MenuItem value={4}>背</MenuItem>
                <MenuItem value={5}>脚</MenuItem>
                <MenuItem value={6}>肩</MenuItem>
                <MenuItem value={7}>尻</MenuItem>
                <MenuItem value={8}>有</MenuItem>
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel id="type-container">単位</InputLabel>
              <Select
                labelId="type-label"
                id="type"
                name="type"
                value={editedOriginalMenu.type}
                required
                onChange={handleChangeSelect}
                className={classes.selectValue}
              >
                <MenuItem value={1}>自重 (rep, set)</MenuItem>
                <MenuItem value={2}>ウェイト (kg,rep,set)</MenuItem>
                <MenuItem value={3}>距離 (km)</MenuItem>
                <MenuItem value={4}>時間 (min)</MenuItem>
              </Select>
            </FormControl>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              登録
            </Button>
          </form>
        </div>
      </Grid>
    </Grid>
  );
};

export default CreateMenu;
